import {PartnerPenaltyStatus, PENALTY_CENTER_TABS} from '../graphql/types';
import {PenaltyCenterFilters} from './penaltyCenterUtils';

/** 罚单中心列表状态，用于从详情返回 / 刷新时回到原页面 */
export interface PenaltyCenterListState {
    activeTab: PartnerPenaltyStatus;
    filters: PenaltyCenterFilters;
    page: number;
    pageSize: number;
    warehouseId: number;
}

const STATE_KEY_PREFIX = 'penalty-center-list-state-';

// 按路径区分：同一组件挂在 DSP 两个入口与仓库侧，存档互不覆盖
function stateKey(pathname: string): string {
    return `${STATE_KEY_PREFIX}${pathname}`;
}

export function savePenaltyCenterListState(pathname: string, state: PenaltyCenterListState): void {
    try {
        sessionStorage.setItem(stateKey(pathname), JSON.stringify(state));
    } catch {
        // 存储不可用（隐私模式 / 配额满）只是失去恢复能力，不影响查询
    }
}

/** 仓库与存档不一致时不恢复，避免把 A 仓的 DSP 筛选带到 B 仓 */
export function loadPenaltyCenterListState(pathname: string, warehouseId: number): PenaltyCenterListState | null {
    try {
        const raw = sessionStorage.getItem(stateKey(pathname));
        if (!raw) {
            return null;
        }
        const state = JSON.parse(raw) as PenaltyCenterListState;
        if (state.warehouseId !== warehouseId || !PENALTY_CENTER_TABS.includes(state.activeTab)) {
            return null;
        }
        return state;
    } catch {
        return null;
    }
}
